<template lang="pug">
  v-card
    v-card-text.px-4
      v-form(ref="form")
        v-text-field(
          v-model="field.fieldNameRU",
          label="Название поля (RU, KG)")
        v-text-field(
          v-model="field.fieldNameEN",
          label="Название поля (EN)")
        v-layout(justify-center)
          div
            v-checkbox(v-model="field.unique", label="Уникальное поле")
            v-checkbox(v-model="field.required", label="Обязательное поле").mt-0
            v-checkbox(v-model="field.survey", label="Анкета").mt-0
    v-card-actions.pb-4
      v-spacer
      v-btn(@click="cancel").mx-2 {{ edit ? 'Закрыть' : 'Очистить' }}
      v-btn(color="primary" @click.stop="create" v-if="!edit", :disabled="disableBtn").mx-2.create-btn Создать
      v-btn(color="primary" @click.stop="save" v-else).mx-2.create-btn Сохранить
      v-spacer
</template>
<script>
import nanoid from 'nanoid'
export default {
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    editField: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    field: {
      fieldNameRU: '',
      fieldNameEN: '',
      unique: false,
      required: false,
      survey: false
    },
    disableBtn: true
  }),
  watch: {
    'field.fieldNameRU': {
      deep: true,
      handler(val, oldVal) {
        this.disableBtn = JSON.stringify(val).length === JSON.stringify(oldVal).length
      }
    }
  },
  created() {
    if (this.edit) {
      this.field.fieldNameRU = this.editField.label
      this.field.fieldNameRU = this.editField.label_ru
      this.field.fieldNameRU = this.editField.label_kg
      this.field.fieldNameEN = this.editField.label_en
      this.field.unique = this.editField.unique
      this.field.required = this.editField.required
      this.field.survey = this.editField.survey
    }
  },
  methods: {
    create() {
      const id = `checkbox-${nanoid()}`
      let data = {
        id: id,
        schema: {
          type: 'checkbox',
          label: this.field.fieldNameRU,
          label_ru: this.field.fieldNameRU,
          label_kg: this.field.fieldNameRU,
          label_en: this.field.fieldNameEN,
          model: id,
          unique: this.field.unique,
          survey: this.field.survey,
          required: this.field.required
        }
      }
      this.$emit('create-field', data)
      this.clearFields()
    },
    save() {
      let data = {
        label: this.field.fieldNameRU,
        label_ru: this.field.fieldNameRU,
        label_kg: this.field.fieldNameRU,
        label_en: this.field.fieldNameEN,
        unique: this.field.unique,
        survey: this.field.survey,
        required: this.field.required
      }
      this.$emit('edit-field', data)
    },
    cancel() {
      this.disableBtn = true
      if (this.edit) {
        this.$emit('edit-cancel')
      } else {
        this.clearFields()
      }
    },
    clearFields() {
      this.field.fieldNameRU = ''
      this.field.fieldNameEN = ''
      this.field.unique = false
      this.field.required = false
      this.field.survey = false
    }
  }
}
</script>
<style lang="scss" scoped>
.v-card__actions {
  .v-btn {
    border-radius: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Constructor/components/CheckboxField.vue